module.exports = __webpack_public_path__ + "img/storage.b1e95ab2.svg";